import React, { Fragment, useEffect, useState } from 'react';

import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';

import api from '../../../lib/api';
import { useMedia } from 'react-use';
import { Dialog, Combobox, Transition } from '@headlessui/react';
import { showToast } from '../../shared/Toast';
import { url_api_v1_sb_profile_add } from '../../../lib/apiUrl';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { SbCurrentUser } from './SbModel';

export interface SbAddNoteProps {
  currentUser: SbCurrentUser;
  user: any;
  submissionBoardModel?: any; // from sb board
  project?: any; // from sb board
  from?: string; // from sbprofile or sb or sk
  dialogCloseHandler?: (open: boolean) => void;
  profileSelected?: (profileInfo: any) => void;
}
// called from users profile details for SB creator
// to select a give profile or not. Ask project and SB name.
export default function SbShortlistAddNote({
  currentUser,
  user,
  from,
  project,
  submissionBoardModel,
  dialogCloseHandler,
  profileSelected,
}: SbAddNoteProps) {
  const [showDialog, setShowDialog] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] = useState(null);
  const [notes, setNotes] = useState('');

  const isMobileScreen = useMedia('(max-width: 1024px)', false);
  useEffect(() => {
      if (
        submissionBoardModel == undefined ||
        submissionBoardModel == null ||
        project == undefined ||
        project == null
      ) {
        return;
      }
      setSelectedSubmissionBoard(submissionBoardModel);
      setSelectedProject(project);
      handleShowDialog();
  }, [submissionBoardModel]);
  
  const handleShowDialog = () => {
    setShowDialog(true);
  };

  const handleHideDialog = () => {
    setSelectedSubmissionBoard(null);
    if (dialogCloseHandler) {
      dialogCloseHandler(false);
    }
    setShowDialog(false);
  };
  const saveClickHandler = async () => {
    try {
      if (
        selectedProject == undefined ||
        selectedProject == null ||
        selectedSubmissionBoard == undefined ||
        selectedSubmissionBoard == null
      ) {
        throw new Error('Error: Invalid data selection.');
      }
      const url = url_api_v1_sb_profile_add
        .replace(':project_uuid', selectedProject.uuid)
        .replace(':sb_id', selectedSubmissionBoard.id); // `/api/v1/submission_boards/${submissionBoard.id}/shortlist_profile`;
      console.log(selectedSubmissionBoard, selectedProject);
      const response = await api.post(url, {
        project_id: selectedProject.uuid,
        submission_board_id: selectedSubmissionBoard.id,
        profile_id: user.id,
        notes: notes,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error short listing profile.');
      }
      if (profileSelected) {
        await profileSelected({
          project_id: selectedProject.uuid,
          submission_board_id: selectedSubmissionBoard.id,
          profile_id: user.id,
          notes: notes,
        });
      }
      showToast('Shortlisted ' + (user?.first_name ?? ''), 'success');
      handleHideDialog();
    } catch (error) {
      console.error('Error shortlisting profile:', error);
      var errorMsg = error.response?.data?.error;
      showToast(errorMsg ?? 'Failed to shortlist, please try again', 'danger');
    }
  };

  return (
    <div>
      <Transition.Root show={showDialog} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={handleHideDialog}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-customGray" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-left">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative flex flex-col overflow-y-auto bg-white py-1">
                  <div className="overflow-y-auto px-6 py-1 flex flex-col items-center">
                    <div className="flex w-full items-center justify-between py-2">
                      <h2 className="text-lg font-medium text-gray-900">Add Note</h2>
                      <button
                        id={'inviteprofiles_close_model_id'}
                        type="button"
                        className="flex h-8 w-8 items-center justify-center rounded-md "
                        onClick={() => {
                          handleHideDialog();
                        }}
                      >
                        <span className="sr-only">Close menu</span>
                        <XMarkIcon className="h-8 w-8" aria-hidden="true" />
                      </button>
                    </div>
                    <div
                      className="justify-items-center flex flex-col gap-4 max-w-md sm:w-96"
                      style={{ minHeight: '16rem' }}
                    >
                      <div className="flex flex-col pt-4">
                        <div className="flex font-bold">
                          {(user?.firstName ?? '') + ' ' + (user?.lastName ?? '')}
                        </div>
                        <div className="flex font-regular">
                          {submissionBoardModel ? submissionBoardModel.title : ''}
                        </div>
                      </div>
                      <hr className="" />
                      <div className="flex w-full flex-col pt-2 text-xl leading-8 md:text-2xl md:leading-9 font-semibold text-gray-900">
                        {selectedProject && selectedSubmissionBoard && (
                          <>
                            <label
                              htmlFor="notes"
                              className="pt-2 block text-xs font-medium text-gray-900"
                            >
                              Add a note
                            </label>
                            <textarea
                              name={'notes'}
                              rows={4}
                              id={'shortlist_notes_id'}
                              value={notes}
                              className="outline-none block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6 focus:ring-2 focus:ring-inset focus:ring-blue-500"
                              placeholder={'notes'}
                              onChange={(e) => {
                                if (e.target.value.length > 512) {
                                  showToast('You can add max 512 characters.', 'danger');
                                  return;
                                }
                                setNotes(e.target.value);
                              }}
                            />
                          </>
                        )}
                      </div>

                      <div className="text-right">
                        <>
                          <button
                            type="button"
                            id={'shortlist_cancel_button_id'}
                            className="py-2 px-4 inline-flex items-center border text-sm rounded-md shadow-sm bg-white    hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                            onClick={() => {
                              handleHideDialog();
                            }}
                          >
                            {'Cancel'}
                          </button>

                          <button
                            id={'shortlist_button_id'}
                            type="button"
                            className="ml-2 py-2 px-4 rounded text-sm bg-blue-500 text-white hover:bg-blue-600 transition-all duration-100 ease-in"
                            onClick={() => {
                              saveClickHandler();
                            }}
                          >
                            {'Submit'}
                          </button>
                        </>
                      </div>
                    </div>
                  </div>
                  {/* </Dialog> */}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
